"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  POPPER_PLACEMENTS: true,
  POPPER_WIDTH_SIZING: true,
  Popper: true
};
exports.default = exports.Popper = exports.POPPER_WIDTH_SIZING = exports.POPPER_PLACEMENTS = void 0;
var _bind = _interopRequireDefault(require("classnames/bind"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _useWaitForDOMRef = _interopRequireDefault(require("react-overlays/useWaitForDOMRef"));
var _react = require("@floating-ui/react");
var _react2 = _interopRequireWildcard(require("react"));
var _keycode = _interopRequireDefault(require("../keycode/keycode"));
var _useModalManager = require("./useModalManager");
var _nanoid = require("./nanoid");
var _PopperContainer = require("./_PopperContainer");
var _AddChildPropsContext = require("./_AddChildPropsContext");
var _isFunction = require("./isFunction");
var _Popper = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Popper.css") : void 0);
var _Popper2 = require("./_Popper.types");
Object.keys(_Popper2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Popper2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Popper2[key];
    }
  });
});
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable no-param-reassign */

const CSS_BLOCK = 'sapcnqr-popper';
const ARROW_HEIGHT = 8;
const ARROW_WIDTH = 16;
// capture ensures this is called before an underlying modal event listener
const eventListenerOptions = {
  capture: true
};
const POPPER_PLACEMENTS = exports.POPPER_PLACEMENTS = ['bottom-start', 'bottom', 'bottom-end', 'left-start', 'left', 'left-end', 'right-start', 'right', 'right-end', 'top-start', 'top', 'top-end'];
const POPPER_WIDTH_SIZING = exports.POPPER_WIDTH_SIZING = ['none', 'matchTarget', 'minTarget', 'maxTarget'];
const Popper = _props => {
  const addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  const props = addChildProps ? Object.assign(Object.assign({}, _props), addChildProps(Popper, _props)) : _props;
  const modalManager = (0, _useModalManager.useModalManager)();
  const container = (0, _useWaitForDOMRef.default)(undefined);
  const {
    arrowClassName,
    children,
    customContainer,
    disableEdgeDetection,
    disableHideWhenTargetIsHidden,
    disablePopperContainer,
    flipContainer,
    maxWidth,
    offset,
    onEscapeKey,
    onKeyDown,
    popperClassName,
    popperContentProps = {},
    popperMiddleware = [],
    popperPlacement = ['bottom-start', 'top-start', 'bottom-end', 'top-end'],
    popperProps = {},
    renderTargetComponent,
    show,
    showArrow,
    skidding,
    targetClassName,
    targetComponent,
    targetProps,
    widthSizingType = 'none',
    widthSizingTargetRef
  } = props;
  const classnames = _bind.default.bind(_Popper.default);
  const placementsAsArray = Array.isArray(popperPlacement) ? popperPlacement : [popperPlacement];
  const middleware = [(0, _react.offset)({
    mainAxis: offset || 0 + (showArrow ? ARROW_HEIGHT + 2 : 0),
    crossAxis: skidding || 0
  })];
  if (!disableEdgeDetection) {
    const fallbackPlacements = placementsAsArray.slice(1);
    middleware.push((0, _react.flip)({
      fallbackPlacements: fallbackPlacements.length ? fallbackPlacements : undefined,
      boundary: flipContainer || undefined
    }));
  }
  middleware.push((0, _react.shift)({
    boundary: flipContainer
  }));
  const arrowRef = (0, _react2.useRef)(null);
  if (showArrow) {
    middleware.push((0, _react.arrow)({
      element: arrowRef,
      // Account for the border-radius
      padding: 6
    }));
  }
  if (!disableHideWhenTargetIsHidden) {
    middleware.push((0, _react.hide)());
  }
  middleware.push(...popperMiddleware);
  // change the reference target element for the popper
  // to the widthSizingTargetRef if it is provided
  let additionalFloatingOptions = {};
  if (widthSizingTargetRef) {
    additionalFloatingOptions = {
      elements: {
        reference: widthSizingTargetRef === null || widthSizingTargetRef === void 0 ? void 0 : widthSizingTargetRef.current
      }
    };
  }
  const {
    refs,
    floatingStyles,
    context,
    placement,
    elements
  } = (0, _react.useFloating)(Object.assign(Object.assign({}, additionalFloatingOptions), {
    placement: placementsAsArray[0] || undefined,
    open: show,
    middleware,
    whileElementsMounted: _react.autoUpdate
  }));
  const role = (0, _react.useRole)(context, {
    role: (popperProps === null || popperProps === void 0 ? void 0 : popperProps.role) || 'dialog'
  });
  const {
    getReferenceProps: getFloatingUiReferenceProps,
    getFloatingProps
  } = (0, _react.useInteractions)([role]);
  (0, _react2.useEffect)(() => {
    if (show) {
      const modalId = (0, _nanoid.generate)();
      const handleDocumentKeyDown = e => {
        if (modalManager.isTopModal(modalId)) {
          onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
          if (e.keyCode === _keycode.default.codes.esc && onEscapeKey) {
            e.stopPropagation();
            onEscapeKey(e);
          }
        }
      };
      modalManager.add(modalId, container);
      document.addEventListener('keydown', handleDocumentKeyDown, eventListenerOptions);
      return () => {
        document.removeEventListener('keydown', handleDocumentKeyDown, eventListenerOptions);
        modalManager.remove(modalId);
      };
    }
    return () => {};
  }, [show]);
  const {
      className: popperPropsClassName,
      innerRef,
      style: popperPropsStyle,
      role: _role
    } = popperProps,
    otherPopperProps = __rest(popperProps, ["className", "innerRef", "style", "role"]);
  const popperClasses = classnames(CSS_BLOCK, popperClassName, popperPropsClassName);
  const targetClasses = classnames(`${CSS_BLOCK}__target`, targetClassName, targetProps === null || targetProps === void 0 ? void 0 : targetProps.className);
  const contentClasses = classnames(`${CSS_BLOCK}__content`, popperContentProps.className);
  if (!disableHideWhenTargetIsHidden && elements.reference && elements.floating) {
    (0, _react.computePosition)(elements.reference, elements.floating, {
      middleware: [(0, _react.hide)()]
    }).then(({
      middlewareData
    }) => {
      var _a, _b, _c;
      if ((_a = middlewareData.hide) === null || _a === void 0 ? void 0 : _a.referenceHidden) {
        (_b = elements.floating) === null || _b === void 0 ? void 0 : _b.classList.add(`${CSS_BLOCK}--reference-hidden`);
      } else {
        (_c = elements.floating) === null || _c === void 0 ? void 0 : _c.classList.remove(`${CSS_BLOCK}--reference-hidden`);
      }
    });
  }
  const styleOverrides = {};
  if (elements.reference) {
    if (typeof maxWidth === 'number') {
      styleOverrides.maxWidth = `${maxWidth}px`;
    }
    if (widthSizingType === 'minTarget') {
      styleOverrides.minWidth = `${elements.reference.getBoundingClientRect().width}px`;
    }
    if (widthSizingType === 'matchTarget') {
      styleOverrides.width = `${elements.reference.getBoundingClientRect().width}px`;
    }
    if (widthSizingType === 'maxTarget') {
      styleOverrides.maxWidth = `${elements.reference.getBoundingClientRect().width}px`;
    }
  }
  let popper = /*#__PURE__*/_react2.default.createElement("div", Object.assign({}, otherPopperProps, {
    ref: (otherPopperProps === null || otherPopperProps === void 0 ? void 0 : otherPopperProps.ref) ? (0, _reactMergeRefs.default)([otherPopperProps.ref, refs.setFloating]) : refs.setFloating,
    className: popperClasses,
    "data-placement": placement,
    style: Object.assign(Object.assign(Object.assign({}, popperPropsStyle), floatingStyles), styleOverrides)
  }, getFloatingProps(), {
    id: otherPopperProps.id || `${getFloatingProps().id}`
  }), /*#__PURE__*/_react2.default.createElement("div", Object.assign({}, popperContentProps, {
    className: contentClasses,
    ref: innerRef
  }), children), showArrow && (/*#__PURE__*/_react2.default.createElement(_react.FloatingArrow, {
    className: classnames(`${CSS_BLOCK}__arrow`, arrowClassName),
    ref: arrowRef,
    context: context,
    height: ARROW_HEIGHT,
    width: ARROW_WIDTH
  })));
  if (!disablePopperContainer) {
    popper = /*#__PURE__*/_react2.default.createElement(_PopperContainer.PopperContainer, {
      customContainer: customContainer
    }, popper);
  }
  const mergedRef = (targetProps === null || targetProps === void 0 ? void 0 : targetProps.ref) ? (0, _reactMergeRefs.default)([targetProps.ref, refs.setReference]) : refs.setReference;
  const getReferenceProps = () => {
    const floatingUiReferenceProps = getFloatingUiReferenceProps();
    const floatingUiAriaControls = floatingUiReferenceProps['aria-controls'];
    if (floatingUiAriaControls) {
      return Object.assign(Object.assign({}, floatingUiReferenceProps), {
        'aria-controls': otherPopperProps.id || floatingUiAriaControls
      });
    }
    return floatingUiReferenceProps;
  };
  return /*#__PURE__*/_react2.default.createElement(_react2.default.Fragment, null, (0, _isFunction.isFunction)(renderTargetComponent) ? renderTargetComponent(mergedRef, getReferenceProps(), targetClasses, targetProps) : (/*#__PURE__*/_react2.default.createElement("div", Object.assign({}, targetProps, {
    className: targetClasses,
    ref: mergedRef,
    "data-popper-wrapper": true
  }), targetComponent)), show && popper);
};
exports.Popper = Popper;
Popper.displayName = 'Popper';
var _default = exports.default = Popper;